import { formatPrice } from "./formatPrice"

export const formatTotalItem = (price: string, qty: number): string => {
  return formatPrice((Number(price || "0") * qty).toString());
}